/**
 * MApp role groups that grant global admin access (brand-wide data scope).
 */
const GLOBAL_ADMIN_ROLES = ['Full Brand Access', 'PHDV Developer Access'] as const;

/**
 * MApp role groups that grant country-level admin access (scoped to assigned stores).
 */
const COUNTRY_ADMIN_ROLES = [
  'Country Coach',
  'Full BU Access',
  'Restaurant Excellence Leader',
  'Franchise Business Coach',
  'Compliance Coach',
  'Compliance Specialist',
  'QA',
] as const;

const ALL_ADMIN_ROLES: readonly string[] = [...GLOBAL_ADMIN_ROLES, ...COUNTRY_ADMIN_ROLES];

export function hasFullBrandAccess(roles?: string[]): boolean {
  if (!roles) return false;
  return roles.some((r) => (GLOBAL_ADMIN_ROLES as readonly string[]).includes(r));
}

export function isAdmin(roles?: string[]): boolean {
  if (!roles) return false;
  return roles.some((r) => ALL_ADMIN_ROLES.includes(r));
}
